module.exports = __webpack_public_path__ + "img/upgrade4.6e574be4.png";